import React, { useRef, useState, useEffect } from 'react';
import './contest.scss'
import { Box, Container, Grid, Link } from '@mui/material';
function ContestPage() {
const contestCards = [
{
icon: "/assets/banner/contest-page/icon_1.png",
title: "VR180/360°",
description:
"Stereoscopic immersive shorts built for headset and gyroscope viewing.",
},
{
icon: "/assets/banner/contest-page/icon_2.png",
title: "Cinematic VFX",
description:
"High-craft cinematic shorts with mythological scope and emotion.",
},
{
icon: "/assets/banner/contest-page/icon_3.png",
title: "AI + Unreal",
description:
"Experimental films using AI, Unreal Engine, and 3D pipelines.",
},
{
icon: "/assets/banner/contest-page/icon_4.png",
title: "Temple Experiences",
description:
"Captured darshan, aarti, and pilgrimage moments in spatial video.",
},
];
const tracksCards = [
{
pilltext: "VR180 · 360°",
title: "True VR / Immersive",
description:
"VR180 or 360° format for headsets and gyroscope view",
},
{
pilltext: "9:16 Cinematic",
title: "Mobile Immersive Reel",
description:
"Vertical cinematic VFX version for app and social discover",
},
{
pilltext: "Interactive",
title: "360° Story Scene",
description:
"Viewers drag or tilt their phone to explore the scene.",
}
];
const prizeCards = [
{
title: "1ST PRIZE",
badge: "FEATURED",
amount: "₹50K",
description: "+ Paid collaboration with MandirWiki",
},
{
title: "2ND PRIZE",
badge: "",
amount: "₹25K",
description: "+ Featured spotlight on app",
},
{
title: "3RD PRIZE",
badge: "",
amount: "₹15k",
description: "+ Creator badge & merch",
},
{
title: "SHORTLISTED X10",
badge: "",
amount: "₹5k",
description: "+ Recognition badge",
},
{
title: "PAID COLLABORATION",
badge: "",
amount: "Open Brief",
description: "Future VR commissions",
},
{
title: "APP FEATURE",
badge: "",
amount: "All Approved",
description: "Royalty on watch-time",
},
];
const steps = [
{
number: "01",
title: "Pick a Topic",
description: "Browse 100+ curated mythology stories.",
},
{
number: "02",
title: "Register",
description: "Submit your topic.",
},
{
number: "03",
title: "Create",
description: "Produce your 2–3 minute immersive reel.",
},
{
number: "04",
title: "Submit",
description: "Upload your video link and details.",
},
{
number: "05",
title: "Review",
description: "Our jury reviews your entry.",
},
{
number: "06",
title: "Published",
description: "Featured, rewarded, monetized.",
},
];
return (
<>
<Box className="contestPage" >
   <Container maxWidth="md">
      <Grid container spacing={2} justifyContent="left" alignItems="center">
         <Grid size={{ xl: 10, lg: 10, md: 12, sm: 12, xs: 12 }} >
         <Box className="VrBannerText">
            <span className="virtualTab">
            INDIA’S MYTHOLOGY VR CREATOR CHALLENGE
            </span>
            <div>
               <h1 className="mt-4">Create India’s Next Mythology VR reel</h1>
               <p>Submit a 2-3 minute immersive Ramayana, Mahabharata, Devi,
                  Shiva, Vishnu, or pilgrimage story. Win rewards, get featured
                  on MandirWiki, and work with us on future VR experiences.
               </p>
               <div className="d-flex gap-3 bannerButton">
                  <Box className="text-center mt-lg-3">
                     <a href="#formBox" className="btn btn-success text-dark">Submit Your Entry <i className="fa fa-arrow-right ms-1 text-dark"></i></a>
                  </Box>
                  <Box className="text-center mt-lg-3">
                     <a href="/assets/contest/guideline.pdf" target="_blank" className="btn btn-warning text-dark">Explore 100 Topics <i className="fa fa-download ms-1 text-dark"></i></a>
                  </Box>
               </div>
            </div>
         </Box>
      </Grid>
      </Grid>
   </Container>
</Box>
<section>
   <Box className="tempratureBox">
      <Container maxWidth="md">
         <Grid container spacing={2} alignItems="stretch">
            <Grid size={12}>
               <Box className="templeInnerHeading">
                  <h2 className="mt-1">
                     A new immersive home for mythology, on every screen
                  </h2>
                  <p>
                     MandirWiki is building a curated immersive mythology short-video experience for mobile, web, and VR viewers. We're inviting creators to shape the canon with us.
                  </p>
               </Box>
            </Grid>
            {contestCards.map((card, index) => (
            <Grid
            key={index}
            size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 12 }}
            >
            <div className="contest-card">
               <div className="vr-icon">
                  <img
                     src={card.icon}
                     alt={card.title}
                     className="img-fluid"
                     />
               </div>
               <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
               </div>
            </div>
         </Grid>
         ))}
         </Grid>
      </Container>
   </Box>
</section>
<section className="bgLight">
   <Box className="tempratureBox">
      <Container maxWidth="md">
         <Grid container spacing={2} alignItems="stretch">
            <Grid size={12}>
               <Box className="templeInnerHeading">
                  <h2 className="mt-1">
                     Win, get featured, work with us.
                  </h2>
                  <p>
                     Approved publishable videos may be eligible for creator bounty or future paid work with MandirWiki.
                  </p>
               </Box>
            </Grid>
            {prizeCards.map((item, index) => (
            <Grid
            key={index}
            size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}
            >
            <div className="prize-card">
               <div className="prize-header">
                  <span className="prize-title">{item.title}</span>
                  {item.badge && (
                  <span className="featured-badge">
                  {item.badge}
                  </span>
                  )}
               </div>
               <div className="prize-content">
                  <h2>{item.amount}</h2>
                  <p>{item.description}</p>
               </div>
            </div>
         </Grid>
         ))}
         </Grid>
      </Container>
   </Box>
</section>
<section>
   <Container maxWidth="md">
      <Grid container spacing={2} justifyContent="center" alignItems="stretch">
         <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
         <Box className="templeInnerHeading mb-lg-4">
            <h2>From idea to immersive reel in six steps.</h2>
         </Box>
      </Grid>
      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
      <div className='infoGuideBox'>
         <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid container spacing={3}>
               {steps.map((step, index) => (
               <Grid
               key={index}
               size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}
               >
               <div className="infoHeading align-items-start">
                  <h2>{step.number}</h2>
                  <div>
                     <h3>{step.title}</h3>
                     <p>{step.description}</p>
                  </div>
               </div>
            </Grid>
            ))}
         </Grid>
         </Grid>
      </div>
      </Grid>
      </Grid>
   </Container>
</section>
<section>
   <Box className="tempratureBox">
      <Container maxWidth="md">
         <Grid container spacing={2} alignItems="center">
            <Grid size={12}>
               <Box className="templeInnerHeading">
                  <div className="topicFlex">
                     <h2 className="mt-1 text-start">
                        Pick a mythology topic. Build a world.
                     </h2>
                     <a href="#formBox" className="btnWarning">
                     Submit Your Entry
                     <span>➜</span>
                     </a>
                  </div>
               </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <ul className="nav nav-pills topic-tabs" id="topicTab" role="tablist">
               {/* <li className="nav-item">
                  <button className="nav-link active" data-bs-toggle="pill" data-bs-target="#all">
                  All
                  </button>
               </li> */}
               <li className="nav-item">
                  <button className="nav-link" disabled data-bs-toggle="pill" data-bs-target="#ramayana">
                  Ramayana
                  </button>
               </li>
               <li className="nav-item">
                  <button className="nav-link" disabled data-bs-toggle="pill" data-bs-target="#mahabharata">
                  Mahabharata
                  </button>
               </li>
               <li className="nav-item">
                  <button className="nav-link" disabled data-bs-toggle="pill" data-bs-target="#devi">
                  Devi/Shakti
                  </button>
               </li>
               <li className="nav-item">
                  <button className="nav-link" disabled data-bs-toggle="pill" data-bs-target="#shiva">
                  Shiva
                  </button>
               </li>
               <li className="nav-item">
                  <button className="nav-link" disabled data-bs-toggle="pill" data-bs-target="#vishnu">
                  Vishnu/Krishna
                  </button>
               </li>
               <li className="nav-item">
                  <button className="nav-link" disabled data-bs-toggle="pill" data-bs-target="#temple">
                  Temple & Pilgrimage
                  </button>
               </li>
               <li className="nav-item">
                  <button className="nav-link" disabled data-bs-toggle="pill" data-bs-target="#experimental">
                  Experimental
                  </button>
               </li>
            </ul>
            <div className="tab-content mt-4">
               <div className="tab-pane fade show active" id="all">
                  <Grid container spacing={2} justifyContent="center" alignItems="center">
                     <Grid container spacing={3}>
                        <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                        <div className="story-card">
                           <img src="/assets/contest/ram-setu.webp" className="img-fluid story-image" alt="" />
                           <div className="story-overlay"></div>
                           <div className="story-tags">
                              <span className="tag active">
                              VR180
                              </span>
                              <span className="tag">
                              MEDIUM
                              </span>
                           </div>
                           <div className="story-content">
                              <span className="category">
                              RAMAYANA
                              </span>
                              <h3>
                                 THE BUILDING OF RAM SETU
                              </h3>
                              <p>
                                 Witness vanaras lift floating stones across the ocean.
                              </p>
                              <a href="#">
                              Select Topic &nbsp;
                              <span>➜</span>
                              </a>
                           </div>
                        </div>
                     </Grid>
                     <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                     <div className="story-card">
                        <img src="/assets/contest/kurukshetra.webp" className="img-fluid story-image" alt="" />
                        <div className="story-overlay"></div>
                        <div className="story-tags">
                           <span className="tag active">
                           CINEMATIC
                           </span>
                           <span className="tag">
                           ADVANCED
                           </span>
                        </div>
                        <div className="story-content">
                           <span className="category">
                           MAHABHARATA
                           </span>
                           <h3>
                              KURUKSHETRA: THE FIRST DAY
                           </h3>
                           <p>
                              Stand between two armies as conch shells echo.
                           </p>
                           <a href="#">
                           Select Topic &nbsp;
                           <span>➜</span>
                           </a>
                        </div>
                     </div>
                  </Grid>
                  <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                  <div className="story-card">
                     <img src="/assets/contest/shivji.webp" className="img-fluid story-image" alt="" />
                     <div className="story-overlay"></div>
                     <div className="story-tags">
                        <span className="tag active">
                        360°
                        </span>
                        <span className="tag">
                        MEDIUM
                        </span>
                     </div>
                     <div className="story-content">
                        <span className="category">
                        SHIVA
                        </span>
                        <h3>
                           SHIVA ON MOUNT KAILASH
                        </h3>
                        <p>
                           Witness vanaras lift floating stones across the ocean.
                        </p>
                        <a href="#">
                        Select Topic &nbsp;
                        <span>➜</span>
                        </a>
                     </div>
                  </div>
         </Grid>

         <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                  <div className="story-card">
                     <img src="/assets/contest/durga.webp" className="img-fluid story-image" alt="" />
                     <div className="story-overlay"></div>
                     <div className="story-tags">
                        <span className="tag active">
                        VR180
                        </span>
                        <span className="tag">
                        ADVANCED
                        </span>
                     </div>
                     <div className="story-content">
                        <span className="category">
                        DURGA SHAKTI
                        </span>
                        <h3>
                           DURGA'S COSMIC DANCE
                        </h3>
                        <p>
                           Feel Shakti rise from a thousand suns.
                        </p>
                        <a href="#">
                        Select Topic &nbsp;
                        <span>➜</span>
                        </a>
                     </div>
                  </div>
         </Grid>

         <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                  <div className="story-card">
                     <img src="/assets/contest/krishna.webp" className="img-fluid story-image" alt="" />
                     <div className="story-overlay"></div>
                     <div className="story-tags">
                        <span className="tag active">
                        CINEMATIC
                        </span>
                        <span className="tag">
                        ADVANCED
                        </span>
                     </div>
                     <div className="story-content">
                        <span className="category">
                        VISHNU / KRISHNA
                        </span>
                        <h3>
                        KRISHNA'S VISHWARUPA
                        </h3>
                        <p>
                           Behold the universe inside one being.
                        </p>
                        <a href="#">
                        Select Topic &nbsp;
                        <span>➜</span>
                        </a>
                     </div>
                  </div>
         </Grid>

         <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                  <div className="story-card">
                     <img src="/assets/contest/bnaras-ghat.webp" className="img-fluid story-image" alt="" />
                     <div className="story-overlay"></div>
                     <div className="story-tags">
                        <span className="tag active">
                        360°
                        </span>
                        <span className="tag">
                        EASY
                        </span>
                     </div>
                     <div className="story-content">
                        <span className="category">
                        TEMPLE & PILGRIMAGE
                        </span>
                        <h3>
                           AARTI AT KASHI VISHWANATH
                        </h3>
                        <p>
                           Stand on the ghats as 108 lamps light the Ganga.
                        </p>
                        <a href="#">
                        Select Topic &nbsp;
                        <span>➜</span>
                        </a>
                     </div>
                  </div>
         </Grid>

         <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                  <div className="story-card">
                     <img src="/assets/contest/samudra-manthan.webp" className="img-fluid story-image" alt="" />
                     <div className="story-overlay"></div>
                     <div className="story-tags">
                        <span className="tag active">
                        EXPERIMENTAL
                        </span>
                        <span className="tag">
                        EASY
                        </span>
                     </div>
                     <div className="story-content">
                        <span className="category">
                        EXPERIMENTAL
                        </span>
                        <h3>
                          SAMUDRA MANTHAN
                        </h3>
                        <p>
                           Recreate the churning of the cosmic ocean with epic VFX and divine storytelling.
                        </p>
                        <a href="#">
                        Select Topic &nbsp;
                        <span>➜</span>
                        </a>
                     </div>
                  </div>
         </Grid>
         </Grid>
         </Grid>
         </div>
         <div className="tab-pane fade" id="ramayana">
         <h4>Ramayana</h4>
         </div>
         <div className="tab-pane fade" id="mahabharata">
         <h4>Mahabharata</h4>
         </div>
         <div className="tab-pane fade" id="devi">
         <h4>Devi/Shakti</h4>
         </div>
         <div className="tab-pane fade" id="shiva">
         <h4>Shiva</h4>
         </div>
         <div className="tab-pane fade" id="vishnu">
         <h4>Vishnu/Krishna</h4>
         </div>
         <div className="tab-pane fade" id="temple">
         <h4>Temple & Pilgrimage</h4>
         </div>
         <div className="tab-pane fade" id="experimental">
         <h4>Experimental</h4>
         </div>
         </div>
         </Grid>
         </Grid>
      </Container>
   </Box>
</section>
<section className="bgLight">
   <Box className="tempratureBox">
      <Container maxWidth="md">
         <Grid container spacing={2} alignItems="center">
            <Grid size={12}>
               <Box className="templeInnerHeading">
                  <h2 className="mt-1">
                     Three tracks. Pick your craft.
                  </h2>
               </Box>
            </Grid>
            {tracksCards.map((card, index) => (
            <Grid
            key={index}
            size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}
            >
            <div className="contest-card tracksCard">
               <div className="vr-icon">
                  <p>{card.pilltext}</p>
               </div>
               <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
               </div>
            </div>
         </Grid>
         ))}
         </Grid>
      </Container>
   </Box>
</section>
<section>
   <Box className="tempratureBox">
      <Container maxWidth="md">
         <Grid container spacing={6}>
            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
            <Box className="templeInnerHeading mb-4">
               <h2 className="mt-1 text-start">
                  Technical requirements
               </h2>
            </Box>
            <div className="requirementList">
               <ul>
                  <li>Duration: 2–3 Minutes</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>Resolution: 4K Preferred, 1080p Minimum</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>Audio: Clear Narration/Music, No Copyright Violation</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>Format: MP4 Preferred</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>Aspect Ratio: Per Submission Category</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>Creator Must Own All Rights</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>AI Usage Must Be Disclosed</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>No Copied Movie / Game / TV Visuals</li>
               </ul>
            </div>
            <div className="requirementList">
               <ul>
                  <li>No Disrespectful Religious Depiction</li>
               </ul>
            </div>
         </Grid>
         <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
         <Box className="templeInnerHeading mb-4">
            <h2 className="mt-1 text-start">
               Judging criteria
            </h2>
         </Box>
         <div className="judging-card">
            <div className="criteria-item">
               <div className="criteria-header">
                  <div className="criteria-name">
                     <span className="dot">&bull;</span>
                     Mythological Accuracy &amp; Sensitivity
                  </div>
                  <div className="criteria-value">
                     25%
                  </div>
               </div>
               <div className="progress criteria-progress">
                  <div className="progress-bar" style={{ width: '25%' }}>
               </div>
            </div>
         </div>
         <div className="criteria-item">
            <div className="criteria-header">
               <div className="criteria-name">
                  <span className="dot">&bull;</span>
                  Visual Quality
               </div>
               <div className="criteria-value">
                  15%
               </div>
            </div>
            <div className="progress criteria-progress">
               <div className="progress-bar" style={{ width: '15%' }}>
            </div>
         </div>
         </div>
         <div className="criteria-item">
            <div className="criteria-header">
               <div className="criteria-name">
                  <span className="dot">&bull;</span>
                  Immersive Experience
               </div>
               <div className="criteria-value">
                  15%
               </div>
            </div>
            <div className="progress criteria-progress">
               <div className="progress-bar" style={{ width: '15%' }}>
            </div>
         </div>
         </div>
         <div className="criteria-item">
            <div className="criteria-header">
               <div className="criteria-name">
                  <span className="dot">&bull;</span>
                  Storytelling
               </div>
               <div className="criteria-value">
                  15%
               </div>
            </div>
            <div className="progress criteria-progress">
               <div className="progress-bar" style={{ width: '15%' }}>
            </div>
         </div>
         </div>
         <div className="criteria-item">
            <div className="criteria-header">
               <div className="criteria-name">
                  <span className="dot">&bull;</span>
                  Audio &amp; Narration
               </div>
               <div className="criteria-value">
                  15%
               </div>
            </div>
            <div className="progress criteria-progress">
               <div className="progress-bar" style={{ width: '15%' }}>
            </div>
         </div>
         </div>
         <div className="criteria-item">
            <div className="criteria-header">
               <div className="criteria-name">
                  <span className="dot">&bull;</span>
                  Technical Compliance
               </div>
               <div className="criteria-value">
                  15%
               </div>
            </div>
            <div className="progress criteria-progress">
               <div className="progress-bar" style={{ width: '15%' }}>
            </div>
         </div>
         </div>
         </div>
         </Grid>
         </Grid>
      </Container>
   </Box>
</section>
<section className="bgLight">
   <Box className="tempratureBox">
      <Container maxWidth="md">
         <Grid container spacing={2} alignItems="center">
            <Grid size={12}>
               <Box className="templeInnerHeading">
                  <h2 className="mt-1">
                     Mark your calendar.
                  </h2>
               </Box>
            </Grid>
            <Grid
            size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
            >
            <div className="timeline">
               <div className="timeline-item left">
                  <div className="timeline-content">
                     <h5>5th July</h5>
                     <p>Registration Opens</p>
                  </div>
               </div>
               <div className="timeline-item right">
                  <div className="timeline-content">
                     <h5>20 July</h5>
                     <p>Topic Submission</p>
                  </div>
               </div>
               <div className="timeline-item left">
                  <div className="timeline-content">
                     <h5>15 August</h5>
                     <p>Submission Deadline</p>
                  </div>
               </div>
               <div className="timeline-item right">
                  <div className="timeline-content">
                     <h5>22 August</h5>
                     <p>Shortlist Announced</p>
                  </div>
               </div>
               <div className="timeline-item left">
                  <div className="timeline-content">
                     <h5>30 August</h5>
                     <p>Winners Announced</p>
                  </div>
               </div>
               {/* <div className="timeline-item right">
                  <div className="timeline-content">
                     <h5>1 October</h5>
                     <p>App Launch Showcase</p>
                  </div>
               </div> */}
            </div>
         </Grid>
         </Grid>
      </Container>
   </Box>
</section>
<section className="storySection">
      <Container maxWidth="sm">
         <Grid container spacing={2} alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
               <Box className="templeInnerHeading">
                <h3>Submit your entry</h3>
                  <h2 className="mt-1">
                     Pick a story. Build a world.
                  </h2>
               </Box>
            </Grid>
             <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <section className="formBox mt-3" id="formBox">
                  {/* <form>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Full Name</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Email</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Mobile</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">City</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Creator Type</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Selected Topic</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Video Title</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Tools used</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">Video upload link (YouTube unlisted / Drive / Vimeo)</label>
                          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        </div>
                      </div>


                      <div class="col-md-12">
                        <div class="mb-2">
                          <label for="exampleInputEmail1" class="form-label text-start">AI Used: Yes</label>
                          <textarea class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></textarea>
                        </div>
                      </div>

                      <div class="col-md-3 col-6">
                        <div class="mb-2">
                          <div class="form-check">
                          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                          <label class="form-check-label" for="flexRadioDefault1">
                            AI Used: Yes
                          </label>
                        </div>
                        </div>
                      </div>

                      <div class="col-md-4 col-6">
                        <div class="mb-2">
                          <div class="form-check">
                          <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                          <label class="form-check-label" for="flexRadioDefault1">
                            No
                          </label>
                        </div>
                        </div>
                      </div>


                      <div class="col-md-12">
                        <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                        <label class="form-check-label" for="flexCheckDefault">
                          I own all rights to this content, AI usage is disclosed, and the depiction is respectful. I grant MandirWiki rights to review, publish, promote and monetise per contest terms.
                        </label>
                      </div>
                      </div>

                      <div class="col-md-12">
                        <div className="mt-3">
                            <a href="#" className="btnWarning w-100 justify-content-center">
                              Submit Your Entry
                              <span>➜</span>
                            </a>
                          </div>
                      </div>

                    </div>
                  </form> */}

                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfBkF9VAV3n4qnw7Ugog2V6MxRFNkFqtNBwAB-2YqAgPt3NFw/viewform?embedded=true" width="100%" height="1560" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
              </section>
             </Grid>
          </Grid>
        </Container>
      </section>
<section className=" faq-section pt-0">
   <Box className="tempratureBox">
      <Container maxWidth="md">
         <Grid container spacing={2} alignItems="center">
            <Grid size={12}>
               <Box className="templeInnerHeading">
                  <h2 className="mt-1">
                     Frequently Asked Questions
                  </h2>
               </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <div className="accordion custom-accordion" id="faqAccordion">
               <div className="accordion-item">
                  <h2 className="accordion-header">
                     <button className="accordion-button" data-bs-toggle="collapse"
                        data-bs-target="#faq1">
                     Who Can Participate?
                     </button>
                  </h2>
                  <div id="faq1" className="accordion-collapse collapse show"
                     data-bs-parent="#faqAccordion">
                     <div className="accordion-body">
                        Any Individual Or Team In India — VFX Artists, Unreal/Unity
                        Creators, AI Video Artists, 3D Animators, Students,
                        YouTubers, Motion Designers And Devotional Creators.
                     </div>
                  </div>
               </div>
               <div className="accordion-item">
                  <h2 className="accordion-header">
                     <button className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq2">
                     Can I Use AI Tools?
                     </button>
                  </h2>
                  <div id="faq2" className="accordion-collapse collapse"
                     data-bs-parent="#faqAccordion">
                     <div className="accordion-body">
                        Yes. AI usage must be disclosed in the submission form.
                        AI-assisted work is welcome; undeclared AI generation is
                        not.
                     </div>
                  </div>
               </div>
               <div className="accordion-item">
                  <h2 className="accordion-header">
                     <button className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq3">
                     Can I Submit A Normal Cinematic Video?
                     </button>
                  </h2>
                  <div id="faq3" className="accordion-collapse collapse"
                     data-bs-parent="#faqAccordion">
                     <div className="accordion-body">
                        Yes. Cinematic VFX Shorts Are Allowed Alongside VR180 And
                        360°.
                     </div>
                  </div>
               </div>
               <div className="accordion-item">
                  <h2 className="accordion-header">
                     <button className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq4">
                     What Is VR180 / 360?
                     </button>
                  </h2>
                  <div id="faq4" className="accordion-collapse collapse"
                     data-bs-parent="#faqAccordion">
                     <div className="accordion-body">
                        VR180 is stereoscopic 180° immersive video. 360° is
                        monoscopic equirectangular video viewable in headsets or by
                        tilting a phone.
                     </div>
                  </div>
               </div>
               <div className="accordion-item">
                  <h2 className="accordion-header">
                     <button className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq5">
                     Can Teams Participate?
                     </button>
                  </h2>
                  <div id="faq5" className="accordion-collapse collapse"
                     data-bs-parent="#faqAccordion">
                     <div className="accordion-body">
                        Yes. List all collaborators in the submission. Prize money
                        goes to the registering creator.
                     </div>
                  </div>
               </div>
               <div className="accordion-item">
                  <h2 className="accordion-header">
                     <button className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq6">
                     Who Owns The Content?
                     </button>
                  </h2>
                  <div id="faq6" className="accordion-collapse collapse"
                     data-bs-parent="#faqAccordion">
                     <div className="accordion-body">
                        You retain authorship. The organizers get the right to
                        review, publish and promote approved submissions under the
                        contest terms.
                     </div>
                  </div>
               </div>
            </div>
         </Grid>
         </Grid>
      </Container>
   </Box>
</section>

<section className="bgLight storySection pt-0">
      <Container maxWidth="md">
         <Grid container spacing={2} alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <div className="storyHeading">
                Pick a Story. Build a World. <span> Inspire Millions.</span>
              </div>
              <div className="text-center mt-3">
              <a href="/assets/contest/guideline.pdf" target="_blank" className="btnWarning mt-2">
                     Explore 100 Topics
                     <i className="fa fa-download"></i>
                     </a>
                     {/* <a href="#" className="btnSuccess ms-2 mt-2">
                     View Topic List
                     <i className="fa fa-list"></i>
                     </a> */}
                     </div>

                     <div class="contact-card">

                    <div class="contact-icon">
                        <i class="fa fa-envelope-open-o"></i>
                    </div>

                    <div class="contact-content">

                        <p class="contact-text">
                            For any queries, feel free to reach us
                        </p>

                        <a href="mailto:info@mandir.wiki" class="contact-mail">
                            info@mandir.wiki
                        </a>

                    </div>

                </div>
            </Grid>
          </Grid>
        </Container>
      </section>
    </>

);
}
export default ContestPage;